import Swiper from "swiper";
import { A11y, Autoplay, Navigation } from "swiper/modules";
import "@/styles/components/slider.css";

document.querySelectorAll(".element-whymateflex").forEach((el) => {
  const container = el.querySelector(".swiper");

  const swiper = new Swiper(container, {
    modules: [A11y, Autoplay, Navigation],
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
    },
    slidesPerView: 1,
    spaceBetween: 16,
    speed: 700,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 20,
      },
      1440: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 24,
      },
    },
  });

  swiper.autoplay.stop();

  const observer = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        swiper.autoplay.start();
        observer.disconnect();
      }
    },
    {
      threshold: [0.7],
    },
  );

  observer.observe(el);
});
